<ng-container *ngIf="(markers.length || isLoading) && !isError">
  <h4 class="underline">{{ 'general_lang_venues' | translate }}</h4>
  
  <div class="venue-map">
    <!-- Loader -->
    <app-loader *ngIf="isLoading else mapTemplate" [fullHeight]="false"></app-loader>
    <!-- Map -->
    <ng-template #mapTemplate>
      <app-map [markers]="markers"></app-map>
    </ng-template>
  </div>
</ng-container>
